import { RpcEngine } from '../core/rpc.js'
import { METHODS } from '../core/events.js'
import type { WorldbookEntryState, ConversationWorldbookResponse } from '../types/index.js'

export type { WorldbookEntryState, ConversationWorldbookResponse }

export class WorldbookModule {
  constructor(private rpc: RpcEngine) {}

  /** 获取当前会话所有世界书条目状态 */
  getAll(): Promise<ConversationWorldbookResponse> {
    return this.rpc.call(METHODS.WORLDBOOK_GET_ALL, [])
  }

  /** 启用某个条目 */
  enable(entryKey: string): Promise<void> {
    return this.rpc.call(METHODS.WORLDBOOK_TOGGLE, [entryKey, true])
  }

  /** 禁用某个条目 */
  disable(entryKey: string): Promise<void> {
    return this.rpc.call(METHODS.WORLDBOOK_TOGGLE, [entryKey, false])
  }

  /** 批量设置多个条目启用状态 */
  batchToggle(entries: Array<{ entryKey: string; enabled: boolean }>): Promise<void> {
    return this.rpc.call(METHODS.WORLDBOOK_BATCH_TOGGLE, [entries])
  }

  /** 覆盖某个条目的内容（仅对当前会话有效） */
  setContent(entryKey: string, content: string): Promise<void> {
    return this.rpc.call(METHODS.WORLDBOOK_SET_CONTENT, [entryKey, content])
  }

  /** 清除某个条目的内容覆盖（恢复模板内容） */
  clearContent(entryKey: string): Promise<void> {
    return this.rpc.call(METHODS.WORLDBOOK_CLEAR_CONTENT, [entryKey])
  }

  /** 重置所有覆盖（恢复全部条目到模板默认状态） */
  reset(): Promise<void> {
    return this.rpc.call(METHODS.WORLDBOOK_RESET, [])
  }
}
